/* Navigation only: never changes quantities or filters recipes from the page. */
(function () {
  function mount(root) {
    if (root.dataset.phqCategoriesReady) return;
    root.dataset.phqCategoriesReady = 'true';
    var groups = Array.from(root.querySelectorAll('[data-phq-recipe-category]'));
    function update() {
      groups.forEach(function (group) {
        var key = group.getAttribute('data-phq-recipe-category');
        var label = root.querySelector('[data-phq-category-count="' + key + '"]');
        if (!label) return;
        var inputs = Array.from(group.querySelectorAll('[data-phq-v1711-quantity]'));
        var count = inputs.reduce(function (sum, input) {
          return sum + Math.max(0, Math.floor(Number(input.value) || 0));
        }, 0);
        label.textContent = count ? count + (count === 1 ? ' case selected' : ' cases selected') : inputs.length + ' recipes';
        label.parentElement.setAttribute('data-selected', String(count > 0));
      });
    }
    var scheduled = false;
    function queue() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; update(); });
    }
    root.addEventListener('input', queue);
    root.addEventListener('change', queue);
    root.addEventListener('click', queue);
    var cases = root.querySelector('[data-phq-v1711-builder-cases]');
    if (cases) new MutationObserver(queue).observe(cases, {childList:true,subtree:true,characterData:true});
    update();
  }
  function init(scope) { scope.querySelectorAll('.phq-builder-v1935').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
